import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RehabilitationProgramDTO } from '@core/apis/rehabilitation/rehabilitation.dto';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import { IBookingStorageDeleteEvent } from '@core/interfaces/booking.interface';
import { FormatTimePipe } from '@core/pipes/format-time.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { ProductCardComponent } from '../product-card/product-card.component';
import { RehabilitationProgramSubFormatEnum } from '@oranta-mis/sdk';

@Component({
  selector: 'app-rehabilitation-view',
  imports: [CommonModule, TranslocoModule, FormatTimePipe, ProductCardComponent],
  standalone: true,
  templateUrl: './rehabilitation-view.component.html',
  styleUrl: './rehabilitation-view.component.scss',
})
export class RehabilitationViewComponent {
  @Input({ required: true }) public program!: RehabilitationProgramDTO;
  @Output('delete') public delete: EventEmitter<IBookingStorageDeleteEvent> = new EventEmitter();

  public teamPath: string = '';
  public readonly BookingStorageEnum = BookingStorageEnum;
  public readonly RehabilitationSubFormatEnum = RehabilitationProgramSubFormatEnum;

  public ngOnInit(): void {
    this.teamPath = `clinics/${this.program.clinicId}/rehabilitation-program`;
  }
}
